// ============================================================
// BATTLESHIP PAGE
// ============================================================
// This page lives at the /battleship route.
// To link your .exe: place it in the /public folder of your
// React project. After npm run build it will be accessible
// at the root of your site (e.g. your-site.com/battleship.exe)
// ============================================================

export default function Battleship() {
  return (
    <div style={{
      fontFamily: "'Georgia', serif",
      backgroundColor: "#f9f6f1",
      minHeight: "100vh",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      padding: "60px 40px",
      textAlign: "center",
    }}>

      <h1 style={{
        fontSize: "42px",
        fontWeight: "bold",
        marginBottom: "16px",
        color: "#2c2c2c",
      }}>
        Battleship
      </h1>

      <p style={{
        fontSize: "18px",
        color: "#555",
        maxWidth: "560px",
        lineHeight: 1.7,
        marginBottom: "12px",
      }}>
        A full-stack reimagining of the classic board game, built in Python
        with Pygame. Features multiplayer, an AI opponent, power-ups, and
        custom hand-drawn animations.
      </p>

      <p style={{
        fontSize: "14px",
        color: "#888",
        marginBottom: "36px",
      }}>
        Windows only · Requires no installation
      </p>

      {/* ↓ Replace "battleship.exe" with the exact filename of your .exe */}
      <a
        href="/battleship.exe"
        download
        style={{
          backgroundColor: "#2c2c2c",
          color: "#f9f6f1",
          padding: "14px 36px",
          borderRadius: "4px",
          textDecoration: "none",
          fontSize: "16px",
          letterSpacing: "1px",
        }}
      >
        Download &amp; Play
      </a>
      <a
        href="/battleship/play/index.html"
        style={{
          display: "inline-block",
          marginTop: "16px",
          backgroundColor: "#f9f6f1",
          color: "#2c2c2c",
          padding: "14px 36px",
          borderRadius: "4px",
          textDecoration: "none",
          fontSize: "16px",
          letterSpacing: "1px",
          border: "2px solid #2c2c2c",
        }}
      >
        Play in Browser
      </a>

      {/* Back to resume link */}
      <a
        href="/"
        style={{
          marginTop: "32px",
          fontSize: "14px",
          color: "#888",
          textDecoration: "none",
        }}
      >
        ← Back to Resume
      </a>

    </div>
  );
}